import moment from "moment";
import { Cell } from "react-table";
import { Ac2AccessDeviceModel } from "src/api/access/productac-types";
import { BaseTooltip } from "src/components";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import DetailLink from "src/components/DetailLink";
import { PagePath } from "src/pages/product/details";
import { YmdFormat } from "src/utils";

export const AccessDeviceColumns = [
  {
    Header: "출입장치 ID",
    accessor: "id",
    width: 120,
    sticky: "left",
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      const detailPath = `${PagePath.accessDevice.detail.replace(":id", value)}`;
      return (
        <DetailLink to={detailPath} className="text-underline">
          {value}
        </DetailLink>
      );
    },
  },
  {
    Header: "장치 ID",
    accessor: "externalDeviceId",
    width: 160,
    sticky: "left",
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <BaseTooltip contents={value || "-"} isSingleLine className="text-start w-100" />;
    },
  },
  {
    Header: "장치명",
    accessor: "deviceName",
    width: 680,
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <BaseTooltip contents={value || "-"} isSingleLine className="text-start w-100" />;
    },
  },

  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <p className="text-center">{value ? moment(value).format(YmdFormat.FULL) : "-"}</p>;
    },
  },
];

export const AccessDeviceModalColumns = [
  {
    Header: "출입장치 ID",
    accessor: "id",
    width: 120,
    sticky: "left",
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      const detailPath = `${PagePath.accessDevice.detail.replace(":id", value)}`;
      return <BaseNewTabLink path={detailPath} value={value} ellipsis />;
    },
  },
  {
    Header: "장치 ID",
    accessor: "externalDeviceId",
    width: 160,
    sticky: "left",
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <BaseTooltip contents={value || "-"} isSingleLine className="text-start w-100" />;
    },
  },
  {
    Header: "장치명",
    accessor: "deviceName",
    width: 680,
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <BaseTooltip contents={value || "-"} isSingleLine className="text-start w-100" />;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    Cell: ({ value }: Cell<Ac2AccessDeviceModel>) => {
      return <p className="text-center">{value ? moment(value).format(YmdFormat.FULL) : "-"}</p>;
    },
  },
];
